import React from 'react';
import SmartDialog from "../../components/SmartDialog";
import TTLProxy from "../../common/TTLAsyncProxy";
import {TractorRequestEndpoints} from "../../common/ProxyEndpoints";
import Utils from "../../common/Utils";
import StatisticsChart from "../../components/StatisticsChart";
import DialogCollapseSection from "../../components/DialogCollapseSection";
import {Badge, Col, Row} from "reactstrap";
import {FixedValueDisplay} from "../../components/OperationSummaryComponent/OperationSummaryComponent";
import AppVariables from "../../common/AppVariables";
import {RequestStatus, RequestTimeFrame} from "../../common/Constants";
import moment from 'moment';
import NumberLabel from "../../components/NumberLabel/NumberLabel";
import CurrencyLabel from "../../components/CurrencyLabel/CurrencyLabel";
import ErrorView from "../../components/Elements/ErrorView";
import LoadingView from "../../components/Elements/LoadingView";

const brandPrimary =  '#20a8d8';
const brandSuccess =  '#4dbd74';
const brandInfo =     '#63c2de';
const brandDanger =   '#56f837';



class RequestStatisticsDialog extends React.Component {

    static ViewInfo = {

        'admin': {
            request_status: [ 'unassigned' , 'assigned' , 'completed' , 'cancelled'  ],
            statisticsEndpoint: (proxy) => TractorRequestEndpoints.getOperationSummary(),
            renderStatistics: (statistics) => (<Row>

                <Col md={6}>

                    <DialogCollapseSection title="Revenue" initiallyOpen>

                        <Row className="text-center">

                            <Col md={6}>

                                <h6><Badge pill color="secondary"><i className="fa fa-chevron-down"/> Pending</Badge></h6>
                                <FixedValueDisplay id="total_pending_income"
                                                   value={statistics.totalPendingIncome}
                                                   message={AppVariables.CurrencyCode}
                                                   hint="Indicates revenue to be generated from assigned requests"/>
                            </Col>


                            <Col md={6}>

                                <h6><Badge pill color="success"><i className="fa fa-chevron-down"/> Completed</Badge></h6>
                                <FixedValueDisplay id="total_completed_income"
                                                   value={statistics.totalIncome}
                                                   message={AppVariables.CurrencyCode}
                                                   hint="Shows total revenue generated from completed requests"/>
                            </Col>

                        </Row>

                    </DialogCollapseSection>

                    <hr/>

                    <DialogCollapseSection title="Operation" initiallyOpen>

                        <Row>

                            <Col md={4} className="text-center">

                                <h6><Badge pill color={"danger"}>Cancelled <i className="fa fa-close"/></Badge></h6>
                                <FixedValueDisplay id="total_cancelled_requests"
                                                   value={statistics.totalCancelledRequests}
                                                   hint="Shows to total number of requests cancelled within the given time specified"/>

                            </Col>


                            <Col md={4} className="text-center">

                                <h6><Badge pill color={"info"}>Assigned <i className="fa fa-chevron-up"/></Badge></h6>
                                <FixedValueDisplay id="total_assigned_acres"
                                                   value={statistics.totalHectaresAssigned}
                                                   message={Utils.pluralize(statistics.totalHectaresAssigned, "hectare" , "hectares")}
                                                   hint="Shows total hectare(s) assigned to the operator over the time range specified"/>

                            </Col>

                            <Col md={4} className="text-center">

                                <h6><Badge pill >Completed <i className="fa fa-chevron-down"/></Badge></h6>
                                <FixedValueDisplay id="total_completed_acres"
                                                   value={statistics.totalHectaresCompleted}
                                                   message={Utils.pluralize(statistics.totalHectaresCompleted ,"hectare" , "hectares")}
                                                   hint="Shows completed hectares within specified time"/>

                            </Col>

                        </Row>

                    </DialogCollapseSection>

                    <hr/>

                    <DialogCollapseSection title="Refund" initiallyOpen>

                        <Row>

                            <Col md={6}>
                                <b>Amount</b><br/>
                                <CurrencyLabel value={statistics.totalAmountRefunded}/>
                            </Col>

                            <Col md={6}>
                                <b>Total Requests</b><br/>
                                <NumberLabel value={statistics.totalRefundedRequests}/>
                            </Col>

                        </Row>


                    </DialogCollapseSection>

                </Col>

                <Col md={6}>
                    <h5>Details</h5>
                    <span><b>Total Requests</b>: <NumberLabel value={statistics.totalRequests}/></span><br/><hr style={{ marginTop: 4, marginBottom: 4 }}/>
                    <span><b>Assigned Requests</b>: <NumberLabel value={statistics.totalAssignedRequests}/></span><br/><hr style={{ marginTop: 4, marginBottom: 4 }}/>
                    <span><b>Completed Requests</b>: <NumberLabel value={statistics.totalCompletedRequests}/></span><br/><hr style={{ marginTop: 4, marginBottom: 4 }}/>
                    <span><b>Cancelled Requests</b>: <NumberLabel value={statistics.totalCancelledRequests}/></span><br/><hr style={{ marginTop: 4, marginBottom: 4 }}/>
                    <span><b>Unassigned Requests</b>: <NumberLabel value={statistics.totalUnassignedRequests}/></span><br/><hr style={{ marginTop: 4, marginBottom: 4 }}/>
                    <span><b>Unassigned Requests (Paid)</b>: <NumberLabel value={statistics.totalPaidUnassignedRequests}/></span><br/><hr style={{ marginTop: 4, marginBottom: 4 }}/>
                    <span><b>Overall Accumulated Hectarage</b>: <NumberLabel value={statistics.totalHectares}/></span><br/><hr style={{ marginTop: 4, marginBottom: 4 }}/>
                    <span><b>Ideal Total Cost</b>: <CurrencyLabel value={statistics.idealCost}/></span><br/><hr style={{ marginTop: 4, marginBottom: 4 }}/>
                    <span><b>Ideal Total Payout</b>: <CurrencyLabel value={statistics.idealPayout}/></span><br/><hr style={{ marginTop: 4, marginBottom: 4 }}/>
                    <span><b>Ideal Total Commission</b>: <CurrencyLabel value={statistics.idealCommission}/></span><br/>
                </Col>

            </Row>)
        },

        'owner': {
            request_status: [ 'assigned' , 'completed' , 'cancelled'  ],
            statisticsEndpoint: (proxy) => TractorRequestEndpoints.getOwnerOperationSummary(proxy.getUserInfo().owner.id),
            renderStatistics: (statistics) => (<Row>

                <Col md={6}>

                    <DialogCollapseSection title="Revenue" initiallyOpen>

                        <Row className="text-center">

                            <div className="col-md-6 text-center">
                                <h6><Badge pill color={"info"}>Pending <i className="fa fa-chevron-up"/></Badge></h6>
                                <FixedValueDisplay id="total_pending_income"
                                                   value={statistics.totalPendingIncomePayout}
                                                   message={AppVariables.CurrencyCode}
                                                   hint="Indicates revenue to be generated from assigned requests"/>

                            </div>

                            <div className="col-md-6 text-center">

                                <h6><Badge pill color={"success"}>Completed <i className="fa fa-chevron-down"/></Badge></h6>

                                <FixedValueDisplay id="total_completed_income"
                                                   value={statistics.totalIncomePayout}
                                                   message={AppVariables.CurrencyCode}
                                                   hint="Shows total revenue generated from completed requests"/>

                            </div>


                        </Row>

                    </DialogCollapseSection>

                    <hr/>

                    <DialogCollapseSection title="Operation" initiallyOpen>

                        <Row>

                            <div className="col-md-4 text-center">
                                <h6><Badge pill color={"danger"}>Cancelled <i className="fa fa-close"/></Badge></h6>
                                <FixedValueDisplay id="total_cancelled_requests"
                                                   value={statistics.totalCancelledRequests}
                                                   hint="Shows to total number of requests cancelled within the given time specified"/>
                            </div>


                            <div className="col-md-4 text-center">
                                <h6><Badge pill color={"info"}>Assigned <i className="fa fa-chevron-up"/></Badge></h6>
                                <FixedValueDisplay id="total_assigned_acres"
                                                   value={statistics.totalHectaresAssigned}
                                                   message={statistics.totalHectaresAssigned == 1 ? "hectare" : "hectares"}
                                                   hint="Shows total hectare(s) assigned to the tractor over the time range specified"/>
                            </div>

                            <div className="col-md-4 text-center">
                                <h6><Badge pill >Completed <i className="fa fa-chevron-down"/></Badge></h6>
                                <FixedValueDisplay id="total_completed_acres"
                                                   value={statistics.totalHectaresCompleted}
                                                   message={statistics.totalHectaresCompleted == 1 ? "hectare" : "hectares"}
                                                   hint="Shows completed hectares within specified time"/>
                            </div>


                        </Row>

                    </DialogCollapseSection>

                    <hr/>

                </Col>

                <Col md={6}>
                    <h5>Details</h5>
                    <span><b>Total Requests</b>: <NumberLabel value={statistics.totalRequests}/></span><br/><hr style={{ marginTop: 4, marginBottom: 4 }}/>
                    <span><b>Assigned Requests</b>: <NumberLabel value={statistics.totalAssignedRequests}/></span><br/><hr style={{ marginTop: 4, marginBottom: 4 }}/>
                    <span><b>Completed Requests</b>: <NumberLabel value={statistics.totalCompletedRequests}/></span><br/><hr style={{ marginTop: 4, marginBottom: 4 }}/>
                    <span><b>Cancelled Requests</b>: <NumberLabel value={statistics.totalCancelledRequests}/></span><br/><hr style={{ marginTop: 4, marginBottom: 4 }}/>
                    <span><b>Overall Accumulated Hectarage</b>: <NumberLabel value={statistics.totalHectares}/></span><br/><hr style={{ marginTop: 4, marginBottom: 4 }}/>
                </Col>


            </Row>)
        },

        'fbo': {
            request_status: [ 'unassigned' , 'assigned' , 'completed' , 'cancelled'  ],
            statisticsEndpoint: (proxy) => TractorRequestEndpoints.getFBOOperationSummary(proxy.getUserInfo().fbo.id),
            renderStatistics: (statistics) => (<Row>

                <Col md={6}>


                    {/*TODO: Show revenue the FBO has spent on requests*/}

                    <DialogCollapseSection title="Operation" initiallyOpen>

                        <Row>

                            <Col md={4} className="text-center">

                                <h6><Badge pill color={"danger"}>Cancelled <i className="fa fa-close"/></Badge></h6>
                                <FixedValueDisplay id="total_cancelled_requests"
                                                   value={statistics.totalCancelledRequests}
                                                   hint="Shows to total number of requests cancelled within the given time specified"/>

                            </Col>


                            <Col md={4} className="text-center">

                                <h6><Badge pill color={"info"}>Assigned <i className="fa fa-chevron-up"/></Badge></h6>
                                <FixedValueDisplay id="total_assigned_acres"
                                                   value={statistics.totalHectaresAssigned}
                                                   message={Utils.pluralize(statistics.totalHectaresAssigned, "hectare" , "hectares")}
                                                   hint="Shows total hectare(s) assigned to the operator over the time range specified"/>

                            </Col>

                            <Col md={4} className="text-center">

                                <h6><Badge pill >Completed <i className="fa fa-chevron-down"/></Badge></h6>
                                <FixedValueDisplay id="total_completed_acres"
                                                   value={statistics.totalHectaresCompleted}
                                                   message={Utils.pluralize(statistics.totalHectaresCompleted ,"hectare" , "hectares")}
                                                   hint="Shows completed hectares within specified time"/>

                            </Col>

                        </Row>

                    </DialogCollapseSection>

                    <hr/>

                    <DialogCollapseSection title="Refund" initiallyOpen>

                        <Row>

                            <Col md={6}>
                                <b>Amount</b><br/>
                                <CurrencyLabel value={statistics.totalAmountRefunded}/>
                            </Col>

                            <Col md={6}>
                                <b>Total Requests</b><br/>
                                <NumberLabel value={statistics.totalRefundedRequests}/>
                            </Col>

                        </Row>


                    </DialogCollapseSection>

                </Col>

                <Col md={6}>
                    <h5>Details</h5>
                    <span><b>Total Requests</b>: <NumberLabel value={statistics.totalRequests}/></span><br/><hr style={{ marginTop: 4, marginBottom: 4 }}/>
                    <span><b>Assigned Requests</b>: <NumberLabel value={statistics.totalAssignedRequests}/></span><br/><hr style={{ marginTop: 4, marginBottom: 4 }}/>
                    <span><b>Completed Requests</b>: <NumberLabel value={statistics.totalCompletedRequests}/></span><br/><hr style={{ marginTop: 4, marginBottom: 4 }}/>
                    <span><b>Cancelled Requests</b>: <NumberLabel value={statistics.totalCancelledRequests}/></span><br/><hr style={{ marginTop: 4, marginBottom: 4 }}/>
                    <span><b>Pending Requests (Paid)</b>: <NumberLabel value={statistics.totalPaidUnassignedRequests}/></span><br/><hr style={{ marginTop: 4, marginBottom: 4 }}/>
                    <span><b>Overall Accumulated Hectarage</b>: <NumberLabel value={statistics.totalHectares}/></span><br/><hr style={{ marginTop: 4, marginBottom: 4 }}/>
                </Col>

            </Row>)
        },

        'farmer': {
            request_status: [ 'unassigned' , 'assigned' , 'completed' , 'cancelled'  ],
            statisticsEndpoint: (proxy) => TractorRequestEndpoints.getFarmerOperationSummary(proxy.getUserInfo().farmer.id),
            renderStatistics: (statistics) => (<Row>

                <Col md={6}>


                    {/*TODO: Show revenue the Farmer has spent on requests*/}

                    <DialogCollapseSection title="Operation" initiallyOpen>

                        <Row>

                            <Col md={4} className="text-center">

                                <h6><Badge pill color={"danger"}>Cancelled <i className="fa fa-close"/></Badge></h6>
                                <FixedValueDisplay id="total_cancelled_requests"
                                                   value={statistics.totalCancelledRequests}
                                                   hint="Shows to total number of requests cancelled within the given time specified"/>

                            </Col>


                            <Col md={4} className="text-center">

                                <h6><Badge pill color={"info"}>Assigned <i className="fa fa-chevron-up"/></Badge></h6>
                                <FixedValueDisplay id="total_assigned_acres"
                                                   value={statistics.totalHectaresAssigned}
                                                   message={Utils.pluralize(statistics.totalHectaresAssigned, "hectare" , "hectares")}
                                                   hint="Shows total hectare(s) assigned to the operator over the time range specified"/>

                            </Col>

                            <Col md={4} className="text-center">

                                <h6><Badge pill >Completed <i className="fa fa-chevron-down"/></Badge></h6>
                                <FixedValueDisplay id="total_completed_acres"
                                                   value={statistics.totalHectaresCompleted}
                                                   message={Utils.pluralize(statistics.totalHectaresCompleted ,"hectare" , "hectares")}
                                                   hint="Shows completed hectares within specified time"/>

                            </Col>

                        </Row>

                    </DialogCollapseSection>

                    <hr/>

                    <DialogCollapseSection title="Refund" initiallyOpen>

                        <Row>

                            <Col md={6}>
                                <b>Amount</b><br/>
                                <CurrencyLabel value={statistics.totalAmountRefunded}/>
                            </Col>

                            <Col md={6}>
                                <b>Total Requests</b><br/>
                                <NumberLabel value={statistics.totalRefundedRequests}/>
                            </Col>

                        </Row>


                    </DialogCollapseSection>

                </Col>

                <Col md={6}>
                    <h5>Details</h5>
                    <span><b>Total Requests</b>: <NumberLabel value={statistics.totalRequests}/></span><br/><hr style={{ marginTop: 4, marginBottom: 4 }}/>
                    <span><b>Assigned Requests</b>: <NumberLabel value={statistics.totalAssignedRequests}/></span><br/><hr style={{ marginTop: 4, marginBottom: 4 }}/>
                    <span><b>Completed Requests</b>: <NumberLabel value={statistics.totalCompletedRequests}/></span><br/><hr style={{ marginTop: 4, marginBottom: 4 }}/>
                    <span><b>Cancelled Requests</b>: <NumberLabel value={statistics.totalCancelledRequests}/></span><br/><hr style={{ marginTop: 4, marginBottom: 4 }}/>
                    <span><b>Pending Requests (Paid)</b>: <NumberLabel value={statistics.totalPaidUnassignedRequests}/></span><br/><hr style={{ marginTop: 4, marginBottom: 4 }}/>
                    <span><b>Overall Accumulated Hectarage</b>: <NumberLabel value={statistics.totalHectares}/></span><br/><hr style={{ marginTop: 4, marginBottom: 4 }}/>
                </Col>

            </Row>)
        }

    };

    constructor(props){
        super(props);
        this.state = RequestStatisticsDialog.getInitialState({});
        this.proxy = TTLProxy.getInstance();
    }

    static getInitialState({ queryParams, queryHook }){

        return {
            queryParams: queryParams || { },
            queryHook: queryHook || null,
            isBusy: false,
            statistics: null,
            chartData: null,
            error: null
        };

    }

    show(queryParams,queryHook){

        this.setState(RequestStatisticsDialog.getInitialState({
            queryParams,
            queryHook
        }), () => {

            const proxy = this.proxy;

            //  resolve active view with user role
            this._activeViewInfo = RequestStatisticsDialog.ViewInfo[proxy.getUserRole()];

            //  show dialog
            this._dlg.show();

            //  load statistics
            return this.loadStatistics();
        });

    }

    generateChartData(requests,timeFrame){

        const viewInfo = this._activeViewInfo;

        const countRequests = (status,start,end) => {

            const _filtered = requests.filter(x => moment(x.date_created).isBetween(start,end,"milliseconds" , "[)") );
            let _count = 0;
            for(let i = 0, len = _filtered.length;  i < len ; i++){
                _count += _filtered[i].status === status ? 1 : 0;
            }

            return _count;
        };

        const findDateMax = (items,key) => {

            if(items.length > 0) {

               let date = moment(items[0][key]);
               for(let i = 1, len = items.length;  i < len ; i++){
                   let _item = moment(items[i][key]);
                   if(_item.isAfter(date)){
                        date = _item;
                   }
               }

               return date;
            }

        };

        const findDateMin = (items, key) => {

            if(items.length > 0) {

                let date = moment(items[0][key]);
                for(let i = 1, len = items.length;  i < len ; i++){
                    let _item = moment(items[i][key]);
                    if(_item.isBefore(date)){
                        date = _item;
                    }
                }

                return date;
            }
        };

        const generateIntervals = (status) => {

            let results = [];

            if(requests.length === 0)
                return results;

            let max= findDateMax(requests,'date_created');
            let min = findDateMin(requests, 'date_created');

            switch (timeFrame) {
                case RequestTimeFrame.Day:
                    min = min.startOf('day').subtract(5,'days');
                    max = max.endOf('day').add(5,'days');
                    break;
                case RequestTimeFrame.Week:
                    min = min.startOf('week').subtract(3,'week');
                    max = max.endOf('week').add(3,'week');
                    break;
                case RequestTimeFrame.Month:
                    min = min.startOf('month').subtract(3,'month');
                    max = max.endOf('month').add(3, 'month');
                    break;
                case RequestTimeFrame.Year:
                    min = min.startOf('year').subtract(3, 'year');
                    max = max.endOf('year').add(3, 'year');
                    break;
            }

            do{

                let next = min.clone();

                switch (timeFrame) {
                    case RequestTimeFrame.Day:
                        next = next.add(1,'day');
                        break;
                    case RequestTimeFrame.Week:
                        next = next.add(1,'week');
                        break;
                    case RequestTimeFrame.Month:
                        next = next.add(1,'month');
                        break;
                    case RequestTimeFrame.Year:
                        next = next.add(1,'year');
                        break;
                }

                results.push({ peak: countRequests(status,min,next) , time: next });
                min = next;

            }while (min.isSameOrBefore(max));

            return results;
        };

        let _frame = {
            time_frame: timeFrame
        };

        if(viewInfo.request_status.includes('assigned'))
            _frame['assigned_requests'] = generateIntervals(RequestStatus.Assigned);

        if(viewInfo.request_status.includes('unassigned'))
            _frame['unassigned_requests'] = generateIntervals(RequestStatus.Unassigned);

        if(viewInfo.request_status.includes('completed'))
            _frame['completed_requests'] = generateIntervals(RequestStatus.Completed);

        if(viewInfo.request_status.includes('cancelled'))
            _frame['cancelled_requests'] = generateIntervals(RequestStatus.Cancelled);

        return _frame;
    }

    async loadStatistics(){

        const viewInfo = this._activeViewInfo;
        const { queryParams: { pagination, ...qParams } , queryHook } =  this.state;

        this.setState({  isBusy: true });

        try {

            const endpoint = viewInfo.statisticsEndpoint(this.proxy);

            let requestParams = qParams;
            if(queryHook){
                queryHook(endpoint.url,requestParams);
            }

            const response = await this.proxy.processRequest(endpoint.url, requestParams);
            const payload = response.getPayload();
            const requests = payload.tractorRequests;

            this.setState({
                statistics: payload,
                chartData: this.generateChartData(requests,RequestTimeFrame.Day),
                error: null
            });

        }
        catch (e){

            this.setState({
                error: e
            });

        }

        this.setState({  isBusy: false });
    }

    getChartSections(){

        const viewInfo = this._activeViewInfo;
        let items = [];
        if(viewInfo.request_status.includes('assigned'))
            items.push({
                key: 'assigned_requests',
                borderWidth: 2,
                backgroundColor: Utils.convertHex(brandInfo,10),
                borderColor: brandInfo,
                label: 'Assigned Requests'
            });


        if(viewInfo.request_status.includes('unassigned'))
            items.push({
                key: 'unassigned_requests',
                label: 'Unassigned Requests',
                backgroundColor: 'transparent',
                borderColor: brandSuccess,
                pointHoverBackgroundColor: '#fff',
                borderWidth: 2,
            });

        if(viewInfo.request_status.includes('completed'))
            items.push({
                key: 'completed_requests',
                label: 'Completed Requests',
                backgroundColor: 'transparent',
                borderColor: brandDanger,
                pointHoverBackgroundColor: '#fff',
                borderWidth: 1,
                borderDash: [8, 5],
            });

        if(viewInfo.request_status.includes('cancelled'))
            items.push({
                key: 'cancelled_requests',
                label: 'Cancelled Requests',
                backgroundColor: 'transparent',
                borderColor: brandDanger,
                pointHoverBackgroundColor: '#fff',
                borderWidth: 1,
                borderDash: [8, 5],
            });

        return items;
    }

    render(){

        const viewInfo = this._activeViewInfo;
        const { isBusy , statistics , error , chartData  } = this.state;

        return <SmartDialog ref={r => this._dlg = r} title={"Tractor Requests Statistics"} large>

            <LoadingView isBusy={isBusy} message={"Fetching statistics, please hold on..."}>
                <ErrorView error={error} retryCallback={() => this.loadStatistics()}>

                    {statistics && <div className="p-2">

                        {viewInfo.renderStatistics(statistics)}

                        <hr/>

                        <StatisticsChart
                            sessionKey="_req_dlg_stats_chart"
                            title={<h6>Tractor Request Statistics</h6>}
                            timeFrameBtnSize={"sm"}
                            peakOffset={10}
                            chartMarginTop={16}
                            requestTimeFrame={RequestTimeFrame.Day}
                            timeFrames={[
                                {
                                    value: RequestTimeFrame.Day,
                                    label: "Daily"
                                },
                                {
                                    value: RequestTimeFrame.Week,
                                    label: "Weekly"
                                },
                                {
                                    value: RequestTimeFrame.Month,
                                    label: "Monthly"
                                },
                                {
                                    value: RequestTimeFrame.Year,
                                    label: "Yearly"
                                }
                            ]}
                            onTimeFrameChanged={frame => {

                                if(statistics)
                                    this.setState({
                                        chartData: this.generateChartData(statistics.tractorRequests,frame)
                                    });

                            }}
                            sections={this.getChartSections()}
                            data={chartData} />

                    </div>}

                </ErrorView>
            </LoadingView>

        </SmartDialog>
    }

}

export default RequestStatisticsDialog;


// WEBPACK FOOTER //
// ./src/views/Request/RequestStatisticsDialog.js